// PRD 17 — Notification Policy (알림 정책) page entry.
//
// Read-only policy viewer (PRD v1.5/v1.8 + ADM.039): the automatic-notification
// policy (트리거·발송 시점·문구·채널) is configured in the backend/설정; this screen
// only displays it. There is no toggle/edit/save on the page.
//
// PRD 17 §1.2 / §8-2 permission matrix:
//
//   Action              | NO_PERMISSION | READ | WRITE | Root
//   --------------------|:-------------:|:----:|:-----:|:----:
//   LNB entry visible   |       ✓       |  ✓   |   ✓   |  ✓    AdminNavigation.ts (exposed; entry blocked)
//   View policy         |       ✗       |  ✓   |   ✓   |  ✓    useRequirePermission (READ)
//   (channel change/save)|      —       |  —   |   —   |  —    removed — no in-screen edit/save [ADM.039]

import { Trans, useTranslation } from 'react-i18next';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { NotificationSettingsView } from '@/features/notification-settings/components/NotificationSettingsView';
import { SendingReferenceSection } from '@/features/notification-settings/components/SendingReferenceSection';

export function NotificationSettingsPage() {
  const { t } = useTranslation('notification-settings');
  const canRead = useRequirePermission('SYSTEM_MGMT', 'READ');

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <div
          className="mb-5 rounded-md p-3.5 text-[13px] leading-relaxed"
          style={{ background: 'rgba(69,104,134,0.06)', border: '1px solid rgba(69,104,134,0.14)' }}
        >
          <p>
            <Trans t={t} i18nKey="notice.line1" components={{ b: <strong /> }} />
          </p>
          <p>{t('notice.line2')}</p>
        </div>
        <NotificationSettingsView />
        <SendingReferenceSection />
      </div>
    </>
  );
}
